export default "__VITE_ASSET__b0698d5b__"